import './style.sass';

import CrewContainer from '../../layouts-components__common-cases/crew-container';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const team = {
    crewList: [
        {
            crewItemImg: '',
            crewItemTitle: 'Полина Герасимова ',
            crewItemSubtitle: 'Руководитель проектного офиса',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Головко Татьяна',
            crewItemSubtitle: 'Менеджер проекта',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Павел Воробьев',
            crewItemSubtitle: 'Руководитель фронтенд-направления',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Александр Забанов',
            crewItemSubtitle: 'Руководитель бэкенд-направления',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Евгений Терещенко',
            crewItemSubtitle: 'Руководитель отдела бизнес-аналитиков',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Николай Цай',
            crewItemSubtitle: 'Руководитель отдела UX/UI дизайна',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Илья Рыбаков',
            crewItemSubtitle: 'Руководитель QA-отдела',
        },
        {
            crewItemImg: '',
            crewItemTitle: '2 менеджера проекта',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '5 фронтенд-разработчиков',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '4 бэкенд-разработчика',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '5 бизнес-аналитиков',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '4 QA-инженера',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '2 DevOps-инженера',
            crewItemSubtitle: '',
        },
    ],
};

const Team = () => (
    <div className="rgs-team">
        <FullWrapper>
            <div className="rgs-team__Title">Команда</div>
            <CrewContainer container={team} />
        </FullWrapper>
    </div>
);

export default Team;
